import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function ArticleCTA() {
  const { t } = useTranslation();

  return (
    <section className="relative py-0 bg-background-50">
      <div className="flex flex-col lg:flex-row min-h-[500px]">
        <div className="lg:w-1/2 relative overflow-hidden min-h-[350px] lg:min-h-[550px]">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20shot%20of%20curated%20fashion%20collection%20with%20luxury%20leather%20goods%20gold%20jewelry%20pieces%20silk%20scarves%20and%20designer%20fragrance%20bottles%20arranged%20on%20dark%20slate%20surface%20with%20scattered%20rose%20petals%20dramatic%20chiaroscuro%20lighting%20high%20fashion%20editorial%20photography&width=960&height=1100&seq=comparison-v2-left&orientation=portrait"
            alt="Porównanie spreadsheet"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
          <div className="absolute top-8 left-8">
            <span className="text-white/70 text-xs font-medium tracking-wider uppercase">
              {t('comparison.label')}
            </span>
          </div>
          <div className="absolute bottom-8 left-8">
            <h2 className="text-white text-3xl md:text-5xl font-heading font-bold leading-tight">
              {t('comparison.title.line1')}
              <br />
              {t('comparison.title.line2')}
              <br />
              {t('comparison.title.line3')}
            </h2>
          </div>
        </div>

        <div className="lg:w-1/2 flex flex-col items-center justify-center px-6 md:px-12 py-14 md:py-20 bg-background-50">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 text-center leading-tight mb-6">
            {t('comparison.right.title.line1')}
            <br />
            {t('comparison.right.title.line2')}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base text-center leading-relaxed max-w-md mb-10">
            {t('comparison.right.text')}
          </p>
          <Link
            to="/artykul-kakobuy-sheet"
            className="flex items-center gap-2 bg-foreground-900 hover:bg-foreground-950 text-white text-sm md:text-base font-medium px-8 py-3.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('comparison.cta')}
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}